const colors = [
    {
        names: ['s', 'std', 'studium'],
        color: '#3F14FFFF'
    },
    {
        names: ['a', 'ausgang', 'ausg'],
        color: '#f44336'
    },
    {
        names: ['reli', 'religion', 'ethik', 'rk', 'nra', 'ev', 'evang', 'evangelisch', "rel"],
        color: '#5A2D66'
    },
    {
        names: ['m', 'mathe', 'math', 'mathematik', 'tm', 'dg'],
        color: '#4060A0'
    },
    {
        names: ['d', 'deu', 'deutsch', 'german', 'td'],
        color: '#7D2440'
    },
    {
        names: ['e', 'eng', 'englisch', 'english', 'en', 'engl', 'te', 'e3'],
        color: '#FF8C00'
    },
    {
        names: ['frz', 'franze', 'franzsisch', 'french', 'fr', 'franz', 'tf', 'f', 'f3'],
        color: '#8C0091FF'
    },
    {
        names: ['bi', 'bio', 'biologie', 'biology'],
        color: '#008830'
    },
    {
        names: ['ch', 'chemie', 'chemistry'],
        color: '#5C4030'
    },
    {
        names: ['phy', 'physik', 'physics', 'ph'],
        color: '#003040'
    },
    {
        names: ['geo', 'geographie', 'geography', 'gwk', 'gk', 'erde'],
        color: '#604080'
    },
    {
        names: ['geschichte', 'history', 'hist', 'g', 'gesch','h'],
        color: '#D28C28'
    },
    {
        names: ['musik', 'music', 'mu', 'mus', 'me'],
        color: '#E8C8C8'
    },
    {
        names: ['kunst', 'art', 'bildnerische erziehung', 'be'],
        color: '#40C0E0'
    },
    {
        names: ['sport', 'sportunterricht', 'physical education', 'sportunterricht', 'spk', 'spm', 'spg', 'sp'],
        color: '#73FF00FF'
    },
    {
        names: ['informatik', 'it', 'cs', 'edv', 'inf', 'digi'],
        color: '#C8E0DC'
    },
    {
        names: ['ps', 'psychologie', 'psychology', 'philosophie', 'philo', 'philosophy', 'phil'],
        color: '##006030'
    },
    {
        names: ['rus', 'russisch', 'russian', 'ru', 'russ', 'r'],
        color: '#F0591DFF '
    },
    {
        names: ['lat', 'latein', 'latin', 'la', 'l', 'lt'],
        color: '#00B0A8'
    },
    {
        names: ['wpf', 'wahlpflichtfach', 'elective', 'wa', 'epwa'],
        color: '#505050'
    },
    {
        names: ['essen', 'food', 'mittagessen', 'lunch', 'mtg', 'jause'],
        color: '#803301FF'
    },
    {
        names: ['freistunde', 'frei', 'free', 'free period', 'break', 'freizeit', 'pause', 'fz', 'nb'],
        color: '#FFFFFFFF'
    }
];

function isDarkColor(color) {
    // Remove the hash if it's there
    if (color.startsWith('#')) {
        color = color.slice(1);
    }

    // Convert 3-digit hex to 6-digit hex
    if (color.length === 3) {
        color = color.split('').map(c => c + c).join('');
    }

    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance < 0.7; // Dark if luminance is less than 0.5
}

export function getTextColorForBackground(bgColor) {
    //if color is dark, return white text
    if (isDarkColor(bgColor)) {
        return '#FFFFFF';
    }
    //if color is light, return black text
    return '#222222FF';
}

const removeparts = ['tutorium', 'tutor', 'tut'];

export function getColorAndSanitizedString(input) {
    let sanitizedString = input
        .toLowerCase()
        .replace(/\s*\(.*?\)|\s*\[.*?\]/g, '') // Remove content inside () or []
        .replace(/[^a-z0-9\s/]/g, '') // Remove non-alphanumeric characters except /
        .trim();

    if (sanitizedString.includes('/')) {
        sanitizedString = sanitizedString.split('/')[0].trim();
    }

    //remove tutorium from the string replace with empty string
    for (let part of removeparts) {
        sanitizedString = sanitizedString.replace(new RegExp(part, 'g'), '').trim();
    }

    //find / in sanitized string, if yes, take the part[0]
    const parts = sanitizedString.split('/').map(p => p.trim()).filter(p => p);

    const colorEntry = colors.find(entry =>
        entry.names.includes(parts[0])
    );


    const color = colorEntry ? colorEntry.color : null;

    return color;
}